import React, { useEffect, useRef } from "react";

import {
//   springyEmojiCursor,
//   fairyDustCursor,
//   snowflakeCursor,
//   characterCursor,
//   trailingCursor,
//   followingDotCursor,
//   bubbleCursor,
  emojiCursor,
//   ghostCursor,
//   rainbowCursor,
//   clockCursor,
//   textFlag,
} from "./effects";

interface CursorEffectsProps {
  children: React.ReactNode;
  emoji?: string[];
  delay?: number;
}

// this is a simple wrapper that we can put around another component (this will have zero effect on click order, and is invisible)
// we apply cursor effects only to children within this wrapper
export default function CursorEffects({ children, emoji, delay }: CursorEffectsProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!wrapperRef.current) return;

    // initialize the emoji cursor effect on this wrapper element
    const effect = emojiCursor({
      element: wrapperRef.current,
      emoji: emoji,
      delay: delay,
    });

    // watch for container resize and update canvas dimensions
    const resizeObserver = new ResizeObserver(() => {
      const canvas = wrapperRef.current?.querySelector('canvas') as HTMLCanvasElement;
      if (canvas && wrapperRef.current) {
        canvas.width = wrapperRef.current.clientWidth;
        canvas.height = wrapperRef.current.clientHeight;
      }
    });

    resizeObserver.observe(wrapperRef.current);

    return () => {
      effect.destroy();
      resizeObserver.disconnect();
    };
  }, [emoji, delay]);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >

    <div
    ref={wrapperRef}
      style={{
        position: "relative",
        display: "flex",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {children}
    </div>
    </div>
  );
}
